import gsap from 'gsap';

export function animateContactsHero() {
  gsap.to('.contacts-hero-section .onlyFade', {
    y: 0,
    opacity: 1,
    stagger: 0.2,
    duration: 1
  })
}

export function animateContactsMessage() {
  const fadeElements = document.querySelectorAll('.message-section .onlyFade');
  fadeElements.forEach(element => {
    gsap.to(element, {
      y: 0,
      opacity: 1,
      stagger: 0.2,
      duration: 1,
      scrollTrigger: {
        trigger: element,
        start: 'top bottom-=20%',
        end: 'top bottom-=20%',
        once: true,
      }
    })
  })

}
